export enum ModelPortfolios {
    checkpoint_trader = 1,
    deep_market_trader = 2,
    monthly_trend_trader = 3,
    profit_skimmer = 4,
    sector_focus = 5
}
